<template>
  <div class="layout-wrap">
    <!-- <NavDrawer></NavDrawer> -->
    <AccountHeader />
    <v-content class="content-wrap">
      <v-container fluid>
        <AppMain />
      </v-container>
    </v-content>
    <FooterCopyRight />
  </div>
</template>
<script>
// import NavDrawer from './components/NavDrawer';
import AccountHeader from '@/components/Header/AccountHeader';
import FooterCopyRight from '@/components/Footer/FooterCopyRight.vue';
import AppMain from './components/AppMain';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AccountLayout',
  components: {
    AccountHeader,
    FooterCopyRight,
    AppMain
    // NavDrawer
  },
  data() {
    return {};
  },
  computed: {
    // ...mapGetters(['getUserInfo', 'getToken']),
  },
  methods: {
    // ...mapActions(['getUserInfo_act']),
  },
  async mounted() {
    // if (!this.isUndefinedOrNullOrEmpty(window.localStorage.getItem('token')) || !this.isUndefinedOrNullOrEmpty(this.getToken)) {
    //   if (this.isEmpty(this.getUserInfo)) {
    //     await this.getUserInfo_act();
    //   }
    // }
  }
};
</script>
<style lang="stylus" scoped>
.content-wrap {
  background-color: var(--header-color);
}
</style>
